import Vue from "vue";

let ProxyHandler = {
  get(target, key) {
    if (key in target.data) {
      return target.data[key];
    } else if (key in target) {
      return target[key];
    } else {
      return undefined;
    }
  },
  set(target, key, value, receiver) {
    if (key in target.data) {
      target.data[key] = value;
    } else {
      target[key] = value;
    }
    return true;
  },
  ownKeys(target) {
    return Object.keys(target.data);
  }
};

export default ProxyHandler;
